import { initSmoothScroll } from './modules/smooth-scroll';

document.addEventListener('DOMContentLoaded', initSmoothScroll);
